module.exports = __webpack_public_path__ + "static/gsc-logo-d3f5d4c45c22e4cb5180dc8f8642c243.png";